export enum Roles {
    Member = 1,
    PrAffiliate = 2,
    ProviderCampaign = 3,
    Administrator = 4
}
